import { Grid } from '@mui/material';
import { VSpacer } from '@nx-smartmonkey/ui';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DriversLayout } from '../../../components/DriversLayout';
import * as routing from '../../../constants/Routing';
import { useIsLogged } from '../../../hooks/session/useIsLogged';
import { useSessionLogout } from '../../../hooks/session/useSessionLogout';
import Button from '../../../react-components/Button';
import { Text } from '../../../react-components/Text';

export const ExpiredSubscription = () => {
  const { run: logout, success, error } = useSessionLogout();
  const { isLogged } = useIsLogged();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLogged) {
      navigate(routing.AUTH);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLogged]);

  useEffect(() => {
    if (success || error) navigate(routing.AUTH);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success, error]);

  return (
    <DriversLayout>
      <Grid
        display={`flex`}
        flexDirection={`column`}
        justifyContent="center"
        alignItems="center"
        padding={`16px 24px`}
        style={{ width: `100%`, height: `100%` }}
      >
        <Text variant="h6" intlId="drivers.expired_subscription.title" style={{ textAlign: `center` }} />

        <VSpacer large />

        <Button intlId="drivers.expired_subscription.action" onClick={logout} />
      </Grid>
    </DriversLayout>
  );
};
